
import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const app = namespace("app");
@Component({})
export default class SvgIcon extends Vue {
  @Prop({})
  name: string;
}
